import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "@fontsource/ibm-plex-mono/700.css";
import "@fontsource-variable/source-serif-4";
import "@/index.css";
import "@/subscriber_facing/styles/sponsorships.css";
import "vite/modulepreload-polyfill";

document.addEventListener("DOMContentLoaded", function () {
  // SKU accordion behavior
  const skuElements = document.querySelectorAll(".sponsorships-sku");
  skuElements.forEach((element) => {
    element.addEventListener("click", function () {
      const wasActive = this.classList.contains("active");
      skuElements.forEach((el) => {
        el.classList.remove("active");
        const slots = el.querySelector(".sponsorships-slots");
        if (slots) {
          slots.classList.remove("visible");
        }
      });
      if (!wasActive) {
        this.classList.add("active");
        const slotsContainer = this.querySelector(".sponsorships-slots");
        if (slotsContainer) {
          slotsContainer.classList.add("visible");
        }
      }
    });
  });

  // Calendar rendering
  const calendarEl = document.getElementById("sponsorship-calendar");
  const calendarDataEl = document.getElementById("sponsorship-calendar-data");
  if (calendarEl && calendarDataEl) {
    const calendarData = JSON.parse(calendarDataEl.textContent || "[]");
    const newsletterEmail = calendarEl.dataset.newsletterEmail || "";
    const dayHeaders = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    calendarData.forEach((month) => {
      const monthEl = document.createElement("div");
      monthEl.className = "sponsorship-calendar-month";

      const headerEl = document.createElement("div");
      headerEl.className = "sponsorship-calendar-month-header";
      headerEl.textContent = month.name;
      monthEl.appendChild(headerEl);

      const gridEl = document.createElement("div");
      gridEl.className = "sponsorship-calendar-grid";

      // Day-of-week headers
      dayHeaders.forEach((day) => {
        const dayHeaderEl = document.createElement("div");
        dayHeaderEl.className = "sponsorship-calendar-header";
        dayHeaderEl.textContent = day;
        gridEl.appendChild(dayHeaderEl);
      });

      // Weeks
      month.weeks.forEach((week) => {
        week.forEach((day) => {
          const dayEl = document.createElement("div");
          dayEl.className = "sponsorship-calendar-day";

          if (!day.in_month) {
            dayEl.classList.add("sponsorship-calendar-day--outside");
            dayEl.textContent = day.day;
          } else if (day.available) {
            dayEl.classList.add("sponsorship-calendar-day--available");
            dayEl.textContent = day.day;
            dayEl.title = "Available";

            // Make clickable - use the first available slot
            const slot = day.slots.find((s) => s.available);
            if (slot) {
              dayEl.style.cursor = "pointer";
              dayEl.addEventListener("click", () => {
                let href;
                if (slot.behavior === "inquiry") {
                  href = `./sponsorships/inquire/${slot.sku_id}/${slot.id}`;
                } else if (slot.behavior === "email") {
                  href = `mailto:${newsletterEmail}?subject=${encodeURIComponent(
                    slot.date + " " + slot.sku_title
                  )}`;
                } else if (slot.behavior === "stripe") {
                  href = `./sponsorships/slots/${slot.sku_id}/${slot.id}`;
                } else {
                  href = slot.url || "#";
                }
                window.location.href = href;
              });
            }
          } else if (day.booked) {
            dayEl.classList.add("sponsorship-calendar-day--booked");
            dayEl.textContent = day.day;
            dayEl.title = "Booked";
          } else {
            dayEl.classList.add("sponsorship-calendar-day--empty");
            dayEl.textContent = day.day;
          }

          gridEl.appendChild(dayEl);
        });
      });

      monthEl.appendChild(gridEl);
      calendarEl.appendChild(monthEl);
    });
  }
});
